import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import 'antd/dist/reset.css';
import './styles/global.css';

// 设置dayjs为中文
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';

dayjs.locale('zh-cn');
dayjs.extend(relativeTime);
dayjs.extend(updateLocale);

// 获取根容器
const container = document.getElementById('root');
if (!container) {
  throw new Error('Failed to find the root element');
}

// 创建根节点并渲染应用
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);